import Reveal from '@/components/base/Reveal';

export default function CtaSection() {
  return (
    <section id="join" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="relative overflow-hidden rounded-lg border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20sunny%20abstract%20background%20with%20soft%20golden%20light%20rays%20and%20gentle%20banana%20leaf%20shadows%20on%20a%20cream%20wall%2C%20minimal%20elegant%20backdrop%2C%20calm%20inviting%20atmosphere%2C%20clean%20simple%20composition&width=1600&height=600&seq=banana-cta-01&orientation=landscape"
              alt=""
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-foreground-950/55" aria-hidden="true" />
            <div className="absolute inset-0 flex items-center">
              <div className="w-full px-6 py-12 md:px-14 md:py-16">
                <div className="max-w-2xl">
                  <h2 className="font-heading text-2xl font-semibold text-background-50 text-balance md:text-4xl">
                    加入香蕉社区，一起把好资源分享下去
                  </h2>
                  <p className="mt-4 text-sm leading-relaxed text-background-100 md:text-base">
                    无论你是来找图片、看视频，还是想把自己的整理分享给更多人，这里都有你的位置。先从浏览资源开始，再慢慢解锁会员福利。
                  </p>
                  <div className="mt-7 flex flex-col gap-3 sm:flex-row">
                    <a
                      href="#benefits"
                      className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
                    >
                      <i className="ri-vip-crown-2-line text-base" aria-hidden="true" />
                      查看会员福利
                    </a>
                    <a
                      href="#gallery"
                      className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/60 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
                    >
                      <i className="ri-image-2-line text-base" aria-hidden="true" />
                      先逛逛图片资源
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}